import { Component, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { SweetAlertService } from '../services/sweetalert/sweet-alert.service';
import { UserDataService } from '../services/user-data/user-data.service';
import { encryptPledgeData } from '../shared/crypto-js/crypto-js';
import { decrypt } from '../shared/crypto-js/decrypt';
import { decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';
@Component({
    selector: 'app-middleware',
    templateUrl: './middleware.component.html',
    styleUrls: ['./middleware.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MiddlewareComponent implements OnInit {

  userPortfolio: any;
  redirectTo: string;
  decodedFamilyUrl: any;
  decodedGiftUrl: any;
  decodedPortUrl: any;
  cParam: any;
  decodedF15Url: any;
  decodedClientRemapping: any;
  decodedddpiUrl: any;
  decodedpledgeUrl: any;
  decodedholdingfamilyUrl: any;
  private hasReloaded = false;

  constructor(private cookies: CookieService,
    private userDataService: UserDataService,
    private authService: AuthService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    private sweeetalertService: SweetAlertService,
    private dashboardService: DashboardService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.getacesstoken()
  }

  
  getacesstoken() {  
    this.route.queryParams.subscribe(params => {
      if (params['code']) {
        let code = params['code'];
        localStorage.setItem('login_code', code);

        this.dashboardService.getAccessToken(code).subscribe(
          (data) => {
            const token = data?.access_token;
           
            const encryptedToken = encryptPledgeData(token);
            localStorage.setItem('got', encryptedToken);
            if (data?.redirect_page) {
              localStorage.setItem('redirect_page', data.redirect_page);
            } else {
              localStorage.setItem('redirect_page', 'dashboard');
           }
          //  this.getAntsession();

            this.getClientData();
          },
        );
      } else {
        console.error('No code parameter found in URL!');
      }
    });
  }

  getAntsession() {
  this.dashboardService.getAntsession().subscribe(
    (data: any) => {
      console.log(data);

      if (data?.status === 'success' && data?.result?.ant_session) {
        const antsession = data.result.ant_session;

        localStorage.setItem('antsession', antsession);
      }
    },
    (error) => {
      console.log(error);
    }
  );
}


  getClientData() {
    this.dashboardService.getClientData().subscribe(
      (data) => {
        let family_url = sessionStorage.getItem('account_family');
        if (family_url) {
          // Decode the URL
          this.decodedFamilyUrl = decodeURIComponent(family_url);

          // Extract query parameter
          const urlParams = new URLSearchParams(this.decodedFamilyUrl);
          this.cParam = urlParams.get('c');
          // if (this.cParam) {
          //   console.log('Query Parameter c:', this.cParam);
          //   // console.log(this.decodedFamilyUrl);
          // }
        }

        let gift_url = sessionStorage.getItem('gift-accept');
        if (gift_url) {
          this.decodedGiftUrl = decodeURIComponent(gift_url);
          const urlParamsg = new URLSearchParams(this.decodedGiftUrl);
          this.cParam = urlParamsg.get('giftCode');
        }

        let client_remapping = sessionStorage.getItem('dekycencoded');
        if (client_remapping) {
          this.decodedClientRemapping = decodeURIComponent(client_remapping);
          const urlParamsg = new URLSearchParams(this.decodedClientRemapping);
          this.cParam = urlParamsg.get('dekycencoded');
        }


        let port_url = sessionStorage.getItem('holdings');
        if (port_url) {
          this.decodedPortUrl = decodeURIComponent(port_url);
          const urlParamsg = new URLSearchParams(this.decodedPortUrl);
          this.cParam = urlParamsg.get('6');
        }

        let f15_url = sessionStorage.getItem('f15');
        if (f15_url) {
          this.decodedF15Url = decodeURIComponent(f15_url);
          // const urlParamsg = new URLSearchParams(this.decodedGiftUrl);
          // this.cParam = urlParamsg.get('giftCode');
        }

        let ddpi_url = sessionStorage.getItem('ddpi');
        if (ddpi_url) {
          this.decodedddpiUrl = decodeURIComponent(ddpi_url);
        }

        let pledge_url = sessionStorage.getItem('pledge');
        if (pledge_url) {
          this.decodedpledgeUrl = decodeURIComponent(pledge_url);
        }

        let holdingfamily_url = sessionStorage.getItem('family');
        if (holdingfamily_url) {
          this.decodedholdingfamilyUrl = decodeURIComponent(holdingfamily_url);
        }

        this.userPortfolio = data;
        if (this.userPortfolio.emsg == 'Session Expired') {
          this.sweeetalertService.sweetAlert("error", "Something went wrong!!!.please try again");
          this.router.navigate(['/']);
          this.cookies.deleteAll('/');
        } else {
          // if (this.cookies.check('userSessionData')) {
          //   this.cookies.delete('userSessionData');
          // }

          // New
          const decryptedData = decrypt(this.userPortfolio.code); 
          // console.log('deceript', decryptedData);

          this.userDataService.getUserData();

          let userSession = JSON.parse(decryptedData);
          let user_data = userSession;
          let { accountId, login_token, exchEnabled, token } = user_data;
          // let userDataToSetInCookies = { accountId, login_token, exchEnabled, token };
          // this.cookies.set('userSessionData', JSON.stringify(userDataToSetInCookies), { path: '/', secure: true, sameSite: 'Strict' });
          // let redirect_page = user_data?.page || user_data?.redirect_page || user_data?.redirectPage || 'dashboard';

          let userDataLocalStorage = { accountId, login_token, exchEnabled, token};
          let encyptLocalStorage = JSON.stringify(userDataLocalStorage );

          let encryptedSessionLocalStorage  = encryptPledgeData(encyptLocalStorage);
          // Drop previous client profile cache before writing the new session
          localStorage.removeItem('userData');
          localStorage.removeItem('userDataTime');
          localStorage.setItem('encryptedUserSession', encryptedSessionLocalStorage );
          localStorage.setItem('story', 'unseen')
          // let redirect_page = user_data?.page;
          let redirect_page = user_data?.page || localStorage.getItem('redirect_page') || 'dashboard';

          if (redirect_page == 'pnl') {
            this.router.navigate(['/reports/pnl']);
          }
          else if (redirect_page == 'holdings') {
            this.router.navigate(['/portfolio/holdings']);
          }
          else if (redirect_page == 'dekycshifting') {
            this.router.navigate(['/client-remapping-request']);
          }
          else if (redirect_page == 'ledger') {
            this.router.navigate(['/ledger']);
          }
          else if (redirect_page == 'zero-brokerage') {
            this.router.navigate(['/zero-brokerage']);
          }
          else if (redirect_page == 'nominee') {
            this.router.navigate(['/account/nominee']);
          }
          // else if (redirect_page == 'f15') {
          //   this.router.navigate(['/f15']);
          // }
          else if (redirect_page == 'tax-loss-harvesting') {
            this.router.navigate(['/tax-loss-harvesting']);
            // Uat
            // let url = `${environment.copyUrl}/tax-loss-harvesting`;
            // window.open(url, '_self');
          }
          else if (redirect_page == 'financial-proof') {
            this.router.navigate(['/financial-proof']);
          }
          else if (redirect_page == 'referandoffer') {
            this.router.navigate(['/refer-offers']);
          }
          else if (redirect_page == 'myaccount') {
            this.router.navigate(['/account/personal']);
          }
          else if (redirect_page == 'emailmobilemodification') {
            this.router.navigate(['/account/personal']);
          }
          else if (redirect_page == 'bankmodification') {
            this.router.navigate(['/account/bank-detail']);
          }
          else if (redirect_page == 'ddpi') {
            sessionStorage.setItem('ddpi', '/account/ddpi');
            this.router.navigate(['/account/ddpi']);
          }
          else if (redirect_page == 'pledge') {
            this.router.navigate(['/portfolio/holdings/pledge']);
          }
          else if (redirect_page == 'familyaccount') {
            this.router.navigate(['/portfolio/holdings/family']);
          }
          else if (redirect_page == 'corporateactions') {
            this.router.navigate(['/portfolio/corporate-action']);
          }
          else if (redirect_page == 'portfolioanalysis') {
            this.router.navigate(['/portfolio/holdings/portfolioanalysis/reports']);
          }
          else if (redirect_page == 'taxpnl') {
            this.router.navigate(['/reports/tax-pnl']);
          }
          else if (redirect_page == 'download') {
            this.router.navigate(['/reports/download']);
          }
          else if (redirect_page == 'tradebook') {
            this.router.navigate(['/reports/trade-book']);
          }
          else if (redirect_page == 'cmr') {
            this.router.navigate(['/account/cmr']);
          }
        
          else {
            if (sessionStorage.getItem('account_family')) {
              let url = `${this.decodedFamilyUrl}`;
              window.open(url, '_self');
              // this.router.navigate([`${this.decodedFamilyUrl}`]);
              // console.log(this.decodedFamilyUrl);
            }
            else if (sessionStorage.getItem('gift-accept')) {
              let url = `${this.decodedGiftUrl}`;
              window.open(url, '_self');
            }

            else if (sessionStorage.getItem('holdings')) {
              let url = `${this.decodedPortUrl}`;
              window.open(url, '_self');
            }

            else if (sessionStorage.getItem('f15')) {
              let url = `${this.decodedF15Url}`;
              window.open(url, '_self');
            }
            else if (sessionStorage.getItem('ddpi')) {
              let url = `${this.decodedddpiUrl}`;
              window.open(url, '_self');
            }
            else if (sessionStorage.getItem('pledge')) {
              let url = `${this.decodedpledgeUrl}`;
              window.open(url, '_self');
            }
            else if (sessionStorage.getItem('family')) {
              let url = `${this.decodedholdingfamilyUrl}`;
              window.open(url, '_self');
            }
            else {
              this.router.navigate(['/dashboard']);
            }
          }

          this.idleTime();
          this.getClientLoginDetail();
          this.authService.isAuthenticatedSubject.next(true);

        }
      }
    )
  }

  idleTime() {
    this.bnIdle.startWatching(600).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        const code = localStorage.getItem('login_code');
        this.authService.isAuthenticatedSubject.next(false);
        if (code) {
          this.authService.logout(code).subscribe({
            next: () => this.authService.clearClientStorage(),
            error: () => this.authService.clearClientStorage(),
          });
        } else {
          this.authService.clearClientStorage();
        }

        this.router.navigate(['/']);
        this.stopTimer();
      }
    });
  }

  stopTimer() {
    this.bnIdle.stopTimer();
  }

  getClientLoginDetail() {
    this.authService.loginClientDetail().subscribe((data) => { });
  }

}
